<template>
  <v-card hover class="dashboard-widget">
    <v-card-title primary-title>
      <h3>
        <slot name="widget-title"></slot>
      </h3>
    </v-card-title>
    <v-container py-0 px-3>
      <slot name="widget-media" py-0></slot>
    </v-container>

    <v-card-text>
      <slot name="widget-body"></slot>
      <slot></slot>
    </v-card-text>

    <v-slide-y-reverse-transition>
      <v-card-text v-show="showSettings">
        I'm a thing. But, like most politicians, he promised more than he could deliver. You won't
        have time for sleeping, soldier, not with all the bed making you'll be doing. Then we'll go
        with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do
        his laundry? I've got to find a way to escape.
      </v-card-text>
    </v-slide-y-reverse-transition>
    <v-card-actions>
      <v-spacer></v-spacer>
      <slot name="widget-action"></slot>

      <div v-if="haSettingsSlot">
        <v-btn icon flat @click="showSettings = !showSettings" color="secondary">
          <v-icon small>
            {{ showSettings ? 'keyboard_arrow_up' : 'settings' }}
          </v-icon>
        </v-btn>
      </div>
      <div v-if="hasMoreSlot">
        <div class="text-xs-center">
          <v-dialog max-width="75vw" v-model="dialog">
            <v-btn flat icon slot="activator" color="secondary">
              <v-icon small>mdi-information</v-icon>
            </v-btn>

            <v-card>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0 secondary--text">
                    {{ dialogTitle }}
                  </h3>
                </div>
              </v-card-title>

              <v-card-text>
                <slot name="widget-more"></slot>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" flat @click="dialog = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ['src', 'gradient', 'mediaHeight', 'backgroundColor'],
  data() {
    return {
      customBackground: 'background-color: white;',
      customMediaHeight: '100px',
      dialog: false,
      dialogTitle: this.$slots['widget-title'][0].text,
      showSettings: false,
    };
  },
  computed: {
    hasBodySlot() {
      return !!this.$slots['widget-body'];
    },
    hasTitleSlot() {
      return !!this.$slots['widget-title'];
    },
    hasActionSlot() {
      return !!this.$slots['widget-action'];
    },
    hasMoreSlot() {
      return !!this.$slots['widget-more'];
    },
    haSettingsSlot() {
      return !!this.$slots['widget-settings'];
    },
  },
  mounted() {
    if (this.gradient) {
      this.customBackground = 'background: linear-gradient(' + this.gradient + ');';
    } else if (this.backgroundColor) {
      this.customBackground = 'background-color: ' + this.backgroundColor + ';';
    }
    if (this.mediaHeight) {
      this.customMediaHeight = this.mediaHeight;
    }
  },
};
</script>
